// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_n9m","cls2":"CiterightInline-cls2_ldy CiterightInline-cls1_n9m"};